import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {User} from '../../graphql/auth';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';

interface UsersData {
    users: {
        data: User[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_USERS_QUERY = gql`
    query getUsers($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        users(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
              id
              email
              first_name
              last_name
              roles {
                name
              }
            }
            ${gqlPaginatorInfo}
        }
    }
`;

export const getUsers = (count: number, page: number, where?: any, orderBy?: any) => useQuery<UsersData>(
    GET_USERS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            orderBy,
        },
    }
);

export default getUsers;
